// extracted by mini-css-extract-plugin
module.exports = {"IFrame":"contract-iframe_IFrame__3ht23","Modal":"contract-iframe_Modal__2yjTE"};